"use client";

import { c as _c } from "react/compiler-runtime";
import { Box, Heading, HStack, VStack } from "@navikt/ds-react";
import { revalidateLogic } from "@tanstack/react-form";
import { useRegistreringAction } from "@/app/(registrering)/hooks/useRegistreringAction";
import { useRegistreringContextState } from "@/app/(registrering)/state/contextState";
import { narmesteLederInfoSchema } from "@/schemas/nærmestelederFormSchema";
import ErrorAlert from "@/shared/components/ErrorAlert";
import { useAppForm } from "@/shared/components/form/hooks/form";
import { LederGroup } from "@/shared/components/form/LederGroup";
import { SykmeldtGroup } from "@/shared/components/form/SykmeldtGroup";
import { UiSelector } from "@/utils/uiSelectors";
export default function RegistreringForm() {
  const $ = _c(31);
  const {
    submittedData,
    handleSuccess
  } = useRegistreringContextState();
  const {
    startOpprettNarmesteLeder,
    error
  } = useRegistreringAction();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = revalidateLogic();
    t1 = {
      onDynamic: narmesteLederInfoSchema
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== handleSuccess || $[3] !== startOpprettNarmesteLeder) {
    t2 = t3 => {
      const {
        value
      } = t3;
      return startOpprettNarmesteLeder(value, {
        onSuccess() {
          handleSuccess(value);
        }
      });
    };
    $[2] = handleSuccess;
    $[3] = startOpprettNarmesteLeder;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== submittedData || $[6] !== t2) {
    t3 = {
      defaultValues: submittedData,
      validationLogic: t0,
      validators: t1,
      onSubmit: t2
    };
    $[5] = submittedData;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const form = useAppForm(t3);
  let t4;
  if ($[8] !== form) {
    t4 = async e => {
      e.preventDefault();
      e.stopPropagation();
      await form.handleSubmit();
    };
    $[8] = form;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Heading className="mt-2" size="medium" level="2">Sykmeldt</Heading>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== form) {
    t6 = <Box padding="space-16" background="accent-soft" borderRadius="8"><VStack gap="space-24" className="w-full max-w-md">{t5}<SykmeldtGroup form={form} fields="sykmeldt" /></VStack></Box>;
    $[11] = form;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Heading className="mt-2" size="medium" level="2">Nærmeste leder</Heading>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== form) {
    t8 = <Box padding="space-16" background="accent-soft" borderRadius="8"><VStack gap="space-24" className="w-full max-w-md">{t7}<LederGroup form={form} fields="leder" /></VStack></Box>;
    $[14] = form;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== error) {
    t9 = error && <ErrorAlert detail={error} />;
    $[16] = error;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== form.BoundSubmitButton) {
    t10 = <HStack className="mt-0"><form.BoundSubmitButton label="Send inn" uiSelector={UiSelector.SendInn} /></HStack>;
    $[18] = form.BoundSubmitButton;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t6 || $[22] !== t8 || $[23] !== t9) {
    t11 = <VStack gap="space-32">{t6}{t8}{t9}{t10}</VStack>;
    $[20] = t10;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== form.AppForm || $[26] !== t11) {
    t12 = <form.AppForm>{t11}</form.AppForm>;
    $[25] = form.AppForm;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12 || $[29] !== t4) {
    t13 = <VStack gap="space-24"><form data-testid={UiSelector.RegistreringForm} onSubmit={t4}>{t12}</form></VStack>;
    $[28] = t12;
    $[29] = t4;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}